import { render } from "./Home.vue?vue&type=template&id=482e206d&scoped=true"
import script from "./Home.vue?vue&type=script&lang=js"
export * from "./Home.vue?vue&type=script&lang=js"

import "./Home.vue?vue&type=style&index=0&id=482e206d&lang=scss"
import "./Home.vue?vue&type=style&index=1&id=482e206d&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-482e206d"

export default script